import axios from 'axios';
import owlCarousel from 'owl.carousel';
$(document).ready(function(){
    /* owl carousel initiation */
    $('.slider').owlCarousel({
        items:1,
        autoplay:true,
        autoplayTimeout:5000,
        loop:true,
        dots:false,
        navText: ["<i class='ion ion-ios-arrow-back'></i>","<i class='ion ion-ios-arrow-forward'></i>"],
        nav:true,
        margin:0,
        responsive:{
            0:{
                dots:false,
                nav:true
            },
            992:{
                dots:true,
                nav:false
            }
        }
    });
    $('.event-slider').owlCarousel({
        items:1,
        autoplay:false,
        autoplayTimeout:6000,
        loop:true,
        dots:true,
        navText: ["<i class='ion ion-ios-arrow-back'></i>","<i class='ion ion-ios-arrow-forward'></i>"],
        nav:false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        margin:0,
        responsive:{
            768:{
                items:2,
                margin:32,
                nav:true,
                dots:false,
            },
            992:{
                items:1,
                margin:0,
                nav:false,
                dots:true
            },
            1200:{
                items:1,
                margin:0,
                nav:false,
                dots:true
            }
        }
    });
    $('.attraction-slider').owlCarousel({
        items:1,
        autoplay:false,
        autoplayTimeout:6000,
        loop:true,
        dots:false,
        nav:true,
        navText: ["<i class='ion ion-ios-arrow-back'></i>","<i class='ion ion-ios-arrow-forward'></i>"],
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        margin:32,
        responsive:{
            576:{
                items:1,
                margin:15
            },
            768:{
                items:2,
                margin:0
            },
            1200:{
                items:3,
            }
        }
    });
    $('.review-slider').owlCarousel({
        items:1,
        autoplay:true,
        autoplayTimeout:6000,
        loop:false,
        dots:false,
        nav:true,
        navText: ["<i class='ion ion-ios-arrow-back'></i>","<i class='ion ion-ios-arrow-forward'></i>"],
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        margin:32,
        responsive:{
            768:{
                items:2,
            },
            992:{
                items:2,
            },
            1200:{
                items:3,
            }
        }
    });
    $('.food-slider').owlCarousel({
        items:1,
        autoplay:true,
        autoplayTimeout:1500,
        loop:true,
        dots:false,
        nav:true,
        navText: ["<i class='ion ion-ios-arrow-back'></i>","<i class='ion ion-ios-arrow-forward'></i>"],
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        margin:32,
        responsive:{
            576:{
                items:2,
            },
            992:{
                items:2,
            },
            1200:{
                items:3
            }
        }
    });
    $("#lightgallery").lightGallery({
        mousewheel:true,
    }); 
    $(".datepicker").datepicker(); 
    if($("#calendar").length > 0){
        axios.get($("#calendar").attr("data-url")).then((response) => {
            $('#calendar').evoCalendar({
                language: 'en',
                sidebarDisplayDefault:false,
                sidebarToggler:false,
                eventListToggler:false,
                calendarEvents: response.data
            })
        }).catch((errors)=>{
            $("#calendar").addClass("h-100").html(`
                <div class="bg-offset font-weight-bold d-flex flex-column h-100 align-items-center justify-content-center">
                    <p>${errors.toJSON().message}</p>
                    <p>Check network tab for more information</p>
                </div>
            `);
        })
    }
})